var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerLegs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "53px",
    viewBox: "0 0 40 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lower Leg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-43",
    transform: "translate(-196.000000, -274.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.925902,231.318148 C39.4432011,237.089129 39.2198453,247.877226 38.2558348,263.682439 L38.2558348,284.318148 L38.2558348,284.318148 L28.3725123,284.318148 C28.3725123,278.208442 27.302558,270.461067 25.1626493,261.076023 C22.8346171,251.675933 21.5423339,241.756641 21.2857999,231.318148 L38.925902,231.318148 Z M60.1968767,231.318148 C59.9403427,241.756641 58.6480596,251.675933 56.3200273,261.076023 C54.1801187,270.461067 53.1101644,278.208442 53.1101644,284.318148 L53.1101644,284.318148 L43.2268419,284.318148 L43.2268419,284.318148 L43.2268419,263.682439 C42.2628313,247.877226 42.0394756,237.089129 42.5567747,231.318148 L42.5567747,231.318148 Z",
    id: "Lower-Leg"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerLegs);
export default __webpack_public_path__ + "static/media/LowerLegs.44cfbec89e84b89125ddb7bbfddd27ac.svg";
export { ForwardRef as ReactComponent };